import React from 'react';
import { Box } from '@mui/material';
import { useResponsive } from '../../hooks/useMediaQuery';
import MobileNavigation from '../Navigation/MobileNavigation';

// Keep a single component tree for page content. Switching between separate
// MobileLayout / DesktopLayout components remounted every screen and wiped
// in-progress form / menu state whenever the viewport flickered (minimize).
const AdaptiveLayout = ({ children }) => {
  const { isMobile, isTablet } = useResponsive();
  const useMobileChrome = isMobile || isTablet;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        ...(useMobileChrome ? {
          bgcolor: 'background.default',
          paddingTop: 'env(safe-area-inset-top)',
          paddingBottom: 'env(safe-area-inset-bottom)',
        } : {}),
      }}
    >
      <Box
        sx={useMobileChrome ? {
          flex: 1,
          paddingBottom: '80px',
          overflow: 'auto',
          '& input': {
            fontSize: '16px',
          },
        } : {
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
        }}
      >
        {children}
      </Box>
      {useMobileChrome && <MobileNavigation />}
    </Box>
  );
};

export default AdaptiveLayout;
